const oneOffFeeRecord = {
  id: null,
  assignmentId: null,
  description: null,
  payAmount: null,
  billAmount: null,
  date: null,
  notes: null,
  createdBy: null,
  updatedBy: null
}

export default () => Object.assign({}, oneOffFeeRecord)
